'use client';

import { useEffect } from 'react';
import { recordView } from '@/lib/recentlyViewed';
import { trackView } from '@/lib/activityClient';

interface RecordViewProps {
  id: string;
  url: string;
  address: string;
  city: string;
  price: number;
  thumb?: string;
  /** Reported to the server for behaviour-derived alerts; absent on older callers. */
  beds?: number;
  propertyType?: string;
}

/**
 * Invisible: records this listing into the recently-viewed rail, and reports the
 * view to the server.
 *
 * The rail has existed since launch and the server was never told, so the notify job
 * could only ever act for people who had explicitly saved a search — measured live,
 * one account in the entire system. Both recorders fire on the same event because
 * they describe the same fact.
 */
export default function RecordView(props: RecordViewProps) {
  useEffect(() => {
    recordView(props);
    void trackView({
      id: props.id,
      city: props.city,
      price: props.price,
      beds: props.beds,
      propertyType: props.propertyType,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.id]);

  return null;
}
